import { useId, type JSX } from 'react'
import { ErrorList, type ListOfErrors } from '../error-list/error-list'
import { cn } from '~/utils/misc'
import './styles.css?url'

export default function Select({
	className,
	inputProps,
	labelProps,
	options = [],
	errors,
}: {
	className?: string
	options?: { value: string; label: string }[]
	inputProps: Omit<JSX.IntrinsicElements['select'], 'className'>
	labelProps: Omit<JSX.IntrinsicElements['label'], 'className'>
	errors?: ListOfErrors
}) {
	const fallbackId = useId()
	const id = inputProps.id ?? fallbackId
	return (
		<div className={cn('mb-4', className)}>
			<label htmlFor={id} className="text-md text-foreground" {...labelProps} />
			<select
				className={cn(
					'text-md mt-0.5 flex w-full rounded-lg border border-foreground/20 bg-background px-3 py-2 text-foreground ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid]:border-input-invalid',
				)}
				id={id}
				{...inputProps}
			>
				{options?.map(x => (
					<option key={x.value} value={x.value}>
						{x.label}
					</option>
				))}
			</select>

			<ErrorList errors={errors} />
		</div>
	)
}
